export const queryGlobal = `
{
    global {
        topBannerText
        topBannerLink
        topBannerVisible
    }
}
`
